import $ from 'jquery';
import React from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';
import FlipBox from './FlipBox';
import UserStorageUtil from '../../../util/UserStorageUtil';

class SampleLessonLayout extends PreLoginPage{
    constructor(props){
        super(props)
        this.state={

        }

        this.openLesson = this.openLesson.bind(this);

    }

    
    openLesson(event){
       
        var lesIndex = event.currentTarget.dataset.index;
	  
          const samplesLessons = Object.values(this.props.sampleLessons);
          //console.log("tchr sample ",samplesLessons[lesIndex]);

          var lessonidTracking = samplesLessons[lesIndex].lessonUrl;
          var lessonid = samplesLessons[lesIndex].lessonUrl;
          var lessonname = samplesLessons[lesIndex].lessonName;
          var lurl = samplesLessons[lesIndex].lessonUrl;
          var dd = 0;
          var lessonPref = null;
          var testid = null;
          var topicSubTopicMapId = null;
          var accessId = null;
          var classId = null;
          var snippetId = "";
          var source = 0;
          var lessonviewRoute = "/openlessonview";
          
          if(this.props.PLPloggedIn || this.props.PLPloggedIn == "true"){
              lessonviewRoute = "/lessonview";
          }
          
          var _url = lessonviewRoute+"/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&accessId="+accessId+"&classId="+classId+"&src=plp"+"&lessonidTracking="+lessonidTracking+"&tracksource="+this.props.tracksource+"&snid="+snippetId+"&qsrc="+source;
            if(dd > 0){
              _url += "&dd="+dd;
            }
      
            UserStorageUtil.storeSessionItem(lurl,lessonname);
          //console.warn("tchr sampleUrl ",_url);
          window.open(_url,lessonid,'fullscreen=yes,menubar=no,width='+window.innerWidth+',height='+window.innerHeight).focus();
    }


    //sampleLesson.url,sampleLesson.lessonUrl,sampleLesson.lessonName
    getSampleLessonComp(sampleLesson,i){
        return(
                <div className="col-md-12" key={i}>
		    		<a>
						<div className="sample-les samplelessonbox" data-index={i} onClick={this.openLesson}>
							<div className="sampl-img lessonthumb"><img src={"/"+sampleLesson.image} alt={"/"+sampleLesson.lessonName + " - HeyMath! lesson"}/><span className="play-btn"></span></div>
							<div className="sampl-text">
								<h3>{sampleLesson.lessonName}</h3>
								<p>{sampleLesson.description}</p>
							</div>							
							<div className="clear"></div>
						</div>	
					</a>
				</div>
        )
    }

    render(){
        let me = this;
        let samplesLessons = this.props.sampleLessons || {};

        try{
            if(samplesLessons.length != 0){
                this.stitle = <h2 className="tchr-lessons">Sample Lessons</h2>;
            }
        }catch(e){}

        return(

            
        <div className="SampleLessonLayout">
            {this.stitle} 
	 	 	<div className="row"> 
			
			{Object.keys(samplesLessons).map((v, i) => 
                me.getSampleLessonComp(samplesLessons[i],i)
			)}

											
	 	 	</div>
              <div className="productFlipbox"> </div>
            </div>

        )
    }
}

export default SampleLessonLayout;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/SampleLessonLayout.js